export const SessionState = {
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    CONNECTING: 'CONNECTING',
    ACTIVE: 'ACTIVE',
    DEGRADED: 'DEGRADED',
    GRACE: 'GRACE',
    ENDED: 'ENDED',
};
const ALLOWED = {
    PENDING_APPROVAL: new Set([SessionState.CONNECTING, SessionState.ENDED]),
    CONNECTING: new Set([SessionState.ACTIVE, SessionState.ENDED]),
    ACTIVE: new Set([SessionState.DEGRADED, SessionState.GRACE, SessionState.ENDED]),
    DEGRADED: new Set([SessionState.ACTIVE, SessionState.GRACE, SessionState.ENDED]),
    GRACE: new Set([SessionState.ACTIVE, SessionState.ENDED]),
    ENDED: new Set(),
};
export function canTransition(from, to) {
    return ALLOWED[from].has(to);
}
export function isTerminalState(s) {
    return s === SessionState.ENDED;
}
//# sourceMappingURL=lifecycle.js.map